<section [formGroup]="cardDetailsForm" class="bv-vault-card-details tw-mb-0">
  <div class="bv-vault-item-form-row">
    <bit-form-field disableMargin>
      <bit-label>{{ "cardholderName" | i18n }}</bit-label>
      <input id="cardholderName" bitInput formControlName="cardholderName" />
    </bit-form-field>

    <bit-form-field disableMargin>
      <bit-label>{{ "brand" | i18n }}</bit-label>
      <bit-select id="cardBrand" formControlName="brand">
        @for (brand of cardBrands; track brand.value) {
          <bit-option [value]="brand.value" [label]="brand.name"></bit-option>
        }
      </bit-select>
    </bit-form-field>
  </div>

  <div class="bv-vault-card-details__number-row">
    <bit-form-field disableMargin class="bv-vault-card-details__number">
      <bit-label>{{ "number" | i18n }}</bit-label>
      <input
        id="cardNumber"
        bitInput
        formControlName="number"
        type="password"
        class="tw-font-mono"
      />
      <button
        type="button"
        bitIconButton
        bitSuffix
        bitPasswordInputToggle
        data-testid="visibility-for-card-number"
        (toggledChange)="logCardEvent($event, EventType.Cipher_ClientToggledCardNumberVisible)"
      ></button>
      <button
        type="button"
        bitIconButton="bwi-clone"
        bitSuffix
        [appCopyClick]="cardDetailsForm.controls.number.value"
        [valueLabel]="'number' | i18n"
        showToast
        [label]="'copyValue' | i18n"
        [disabled]="!cardDetailsForm.controls.number.value"
        data-testid="copy-card-number-button"
      ></button>
    </bit-form-field>

    <bit-form-field disableMargin>
      <bit-label>{{ "expirationMonth" | i18n }}</bit-label>
      <bit-select id="cardExpMonth" formControlName="expMonth">
        @for (month of expirationMonths; track month.value) {
          <bit-option [value]="month.value" [label]="month.name"></bit-option>
        }
      </bit-select>
    </bit-form-field>

    <bit-form-field disableMargin>
      <bit-label>{{ "expirationYear" | i18n }}</bit-label>
      <input
        id="cardExpYear"
        bitInput
        formControlName="expYear"
        type="number"
        placeholder="ex. 2029"
      />
    </bit-form-field>
  </div>

  <bit-form-field disableMargin class="bv-vault-card-details__code">
    <bit-label>{{ "securityCode" | i18n }}</bit-label>
    <input id="cardCode" bitInput formControlName="code" type="password" class="tw-font-mono" />
    <button
      type="button"
      bitIconButton
      bitSuffix
      bitPasswordInputToggle
      data-testid="visibility-for-card-code"
      (toggledChange)="logCardEvent($event, EventType.Cipher_ClientToggledCardCodeVisible)"
    ></button>
  </bit-form-field>
</section>
